module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_summersale_small_en-46f0f9965f9a6c58d9139991b01b2166.jpg";